import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { UtilService } from './util.service';
import { Http, RequestOptions, Headers } from '@angular/http';

declare var $: any;
@Injectable()
export class MasterService {

  constructor(
    private apiService:ApiService,
    private util:UtilService, 
    private http: Http
  ) { }

  async  InitDropDown(system: string, action: string, data: any, id: string) {
    var res: any =  await this.apiService.post(system, action, data);
    $('#' + id).find('option').remove().end();
    console.log(res);
    if (res.isSuccess) {
      var obj: any = res.responseData;
      var select = <HTMLSelectElement>document.getElementById(id);
      for (var i = 0; i < obj.length; i++) {
        var opt = document.createElement('option');
        opt.value = obj[i].ddl_value;
        opt.innerHTML = obj[i].ddl_text;
        select.appendChild(opt);
      }
    } else {
       this.util.ErrorDialog(obj.errorMessage);
    }
  }

  async GetMaxUploadFileSize() {
    var Config: any = {};
    var DefaultValue = 10;
    Config = await this.apiService.get("master", "configuration");
    if (Config != null && Config.length > 0) {
      var ConfigAgentBank = Config.filter((a: any) => a.dpa_name == "UPLOAD_FILE_AGENT");
      if (ConfigAgentBank != null && ConfigAgentBank.length > 0)
        return ConfigAgentBank[0].dpa_value;
      else
        return DefaultValue;
    }
    else 
      return DefaultValue;
  }

  async GetAcceptUploadFileExtension() {
    var DefaultValue = ".jpg, .jpeg, .pdf, .doc, .docx";
    var Config: any = {}
    Config = await this.EnvConfig(); 
    if (Config == null)
      return DefaultValue;
    else
      return Config.AcceptUploadFileExtension;
  }

  async EnvConfig() {
    return new Promise(resolve => {
      this.http.get('./assets/env.json').toPromise().then((data) => {
        const res = data.json();
        resolve(res);
      }).catch((err) => {
        resolve(null);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/utility/master.service.ts